<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <div
                    *ngIf="processConfig?.optionalExternalEval then thenBlock; else elseBlock"
            ></div>

            <ng-template #thenBlock>
                <ion-label
                        style="margin-left: 15%"
                        class="ion-text-center"
                        text-wrap
                        color="primary">
                    {{
                        getText(processConfig?.globalizationConfig, 'title') | uppercase
                    }}
                </ion-label>

                <ion-button
                        text-wrap
                        mode="ios"
                        color="primary"
                        (click)="requestExternalEvaluation()">
                    {{ 'externalEvaluation.requestEval' | translate }}
                </ion-button>
            </ng-template>

            <ng-template #elseBlock>
                <ion-label class="ion-text-center ion-text-wrap">
                    {{
                        getText(processConfig?.globalizationConfig, 'title') | uppercase
                    }}
                </ion-label>
            </ng-template>
        </ion-item>

        <app-step-description [description]="'360evaluation.indexDescription' | translate">
        </app-step-description>

        <ion-card mode="ios" class="team-card">
            <ion-card-header color="">
                <ion-card-title>
                    {{ '360evaluation.evaluationsToDo' | translate | uppercase }}
                </ion-card-title>
            </ion-card-header>
            <ng-container *ngIf="divide360UsersLitByAreaEnabled">
                <div class="areas-tab-background">
                    <div class="areas-tab">
                        <div *ngFor="let area of areas"
                             [ngStyle]="{'width': (areas && areas.length > 0) ? (100 / areas.length) + '%' : 'auto'}"
                             [ngClass]="{ 'area-tab-selected': (areaIdSelected === area.areaId), 
                                          'area-tab-not-selected': (areaIdSelected !== area.areaId)}"
                             (click)="changeTab(area.areaId)">
                            <ion-label>{{ getText(area.globalizationConfig, 'title') | uppercase }}</ion-label>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ion-card-content class="ion-no-padding">
                <app-evaluation-users-list
                        [users]="users"
                        [managerEvals]="managerEvals"
                        [processConfig]="processConfig"
                        [cycleId]="_cycleId"
                        [area]="areaSelected"
                        [evaluatorCycleParticipantId]="evaluatorCycleParticipantId"
                        [haveAccessToChangeRelationship]="haveAccessToChangeRelationship"
                        [haveAccessToDelete]="haveAccessToDelete"
                        [isAllowedToReopen]="isAllowedToReopen"
                        (loadUsersFor360Evaluation)="loadUsersFor360Evaluation()"
                        (goToEvaluation)="goToEvaluation($event)">
                </app-evaluation-users-list>
            </ion-card-content>
        </ion-card>
    </div>
</ion-content>
